import { templateConstants } from "../../../../constants/cms/template/template.constants";
import { alertActions } from "../../alert.action";
import { templateService } from "../../../../services/cms/template/template.service";
import {
  deepClone,
  checkForTemplateUpdates,
} from "../../../../helpers/objectHelper";
import {
  insertGoogleFonts,
  insertFonts,
  extractFontsFromJson,
} from "../../../../helpers/fontHelper";
import { defaultTemplate } from "../../../../cms/areas/template/models/defaultTemplate";
import { cmsActions } from "../cms.action";
import { menuService } from "../../../../services/cms/menu/menu.service";
import { templateHelper } from "../../../../cms/areas/template/helpers/templateHelper";
import { history } from "../../../../helpers/history";
export const templateActions = {
  update,
  softUpdate,
  create,
  select,
  getAll,
  remove,
  get,
  getDefaultTemplateByEvent,
  checkForUpdates,
  deselect,
  togglePreviewMode,
};

function togglePreviewMode(device) {
  return (dispatch) => {
    dispatch(success(device));
  };
  function success(element, source) {
    return { type: templateConstants.TOGGLE_PREVIEW_MODE, device };
  }
}

function remove(element, source) {
  return (dispatch) => {
    dispatch(success(element, source));
  };
  function success(element, source) {
    return {
      type: templateConstants.DELETE_TEMPLATE_ELEMENT_SUCCESS,
      element,
      source,
    };
  }
}
function select(element) {
  return (dispatch) => {
    dispatch(success(element));
  };
  function success(element) {
    return { type: templateConstants.SELECT_TEMPLATE_ELEMENT, element };
  }
}
function toggleMenuModal() {
  return (dispatch) => {
    dispatch(toggle());
  };
  function toggle() {
    return { type: templateConstants.TOGGLE_MENU_MODAL };
  }
}
function deselect() {
  return (dispatch) => {
    dispatch(success());
  };
  function success() {
    return { type: templateConstants.DESELECT_SUCCESS };
  }
}
function softUpdate(template) {
  return (dispatch) => {
    if (template.inherit === true) {
      dispatch(cmsActions.inheritageAffected(true));
    }
    dispatch(success(template));
  };
  function success(template) {
    return { type: templateConstants.SOFT_UPDATE_TEMPLATE, template };
  }
}

function create(eventId, name = null) {
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());

    const newTemplate = {
      eventId,
      name: name ? name : "Default Template",
      style: JSON.stringify({ ...defaultTemplate }),
    };

    templateService.create(newTemplate).then(
      (template) => {
        dispatch(success(template));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: templateConstants.CREATE_TEMPLATE_FAILURE };
  }
  function success(template) {
    return { type: templateConstants.CREATE_TEMPLATE_SUCCESS, template };
  }
  function failure(error) {
    return { type: templateConstants.CREATE_TEMPLATE_FAILURE, error };
  }
}

function getAll(eventId, includeInherited = false) {
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());
    templateService.getAllByEvent(eventId, includeInherited).then(
      (templates) => {
        if (templates && templates !== undefined && templates.length > 0) {
          const newTemplates = deepClone(templates);
          newTemplates.map((t) => {
            t.content = JSON.parse(t.content);
            t.content = checkForTemplateUpdates(t.content, defaultTemplate);
          });
          dispatch(success(newTemplates));
        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: templateConstants.GET_TEMPLATE_BY_EVENT_REQUEST };
  }
  function success(templates) {
    return { type: templateConstants.GET_TEMPLATE_BY_EVENT_SUCCESS, templates };
  }
  function failure(error) {
    return { type: templateConstants.GET_TEMPLATE_BY_EVENT_FAILURE, error };
  }
}
function getDefaultTemplateByEvent(eventId) {
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());
    templateService.getDefaultByEvent(eventId).then(
      (template) => {
        template.content = JSON.parse(template.content);
        template.content = checkForTemplateUpdates(
          template.content,
          defaultTemplate
        );
        dispatch(success(template));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_REQUEST };
  }
  function success(template) {
    return {
      type: templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_SUCCESS,
      template,
    };
  }
  function failure(error) {
    return {
      type: templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_FAILURE,
      error,
    };
  }
}
function checkForUpdates(template, allowOverWrite = false) {
  return (dispatch) => {
    dispatch(alertActions.clear());
    return dispatch(update(template));
  };
}
function get(templateId) {
  return dispatch => {
    dispatch(request());
    dispatch(alertActions.clear());
    templateService.get(templateId).then(
      (template) => {
        /*   menuService.getByEvent(template.eventId).then(
            menu => { */
        if (template && template !== undefined) {
          template.content = JSON.parse(template.content);
          template.content = checkForTemplateUpdates(
            template.content,
            defaultTemplate
          );
          template.content = templateHelper.assignResponsiveStyle(
            template.content
          );
          /*          if (template.content.header.content === undefined) template.content.header.content = [];
                   if (template.content.footer.content === undefined) template.content.footer.content = []; */
          dispatch(success(template /* , menu */));
        }
        /* },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        } */
        /* ); */
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: templateConstants.GET_TEMPLATE_REQUEST };
  }
  function success(template /* , menu */) {
    return {
      type: templateConstants.GET_TEMPLATE_SUCCESS,
      template /* , menu */,
    };
  }
  function failure(error) {
    return { type: templateConstants.GETALL_TEMPLATE_FAILURE, error };
  }
}
function update(template, callback = null) {
  const templateDto = {
    templateId: template.templateId,
    eventId: template.eventId,
    name: template.name,
    inherit: template.inherit,
    style: JSON.stringify(template.content),
    fonts: extractFontsFromJson({ content: template.content }),
  };
  return (dispatch) => {
    dispatch(request());
    dispatch(alertActions.clear());
    templateService.update(templateDto).then(
      (t) => {
        if (t && t !== undefined) {
          t.content = JSON.parse(t.content);
          dispatch(success(t));

          if(typeof callback == 'function'){
            callback();
          }

        }
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request() {
    return { type: templateConstants.UPDATE_TEMPLATE_REQUEST };
  }
  function success(template) {
    return { type: templateConstants.UPDATE_TEMPLATE_SUCCESS, template };
  }
  function failure(error) {
    return { type: templateConstants.UPDATE_TEMPLATE_FAILURE, error };
  }
}
